import React from 'react';

const handleReloadPageClick = () => window.location.reload();

const ErrorBoundaryFallback = () => {
  return (
    <div className={'alert alert-danger'}>
      <h4>Error occurred</h4>
      <p>
        Something went wrong. Let`s try to{' '}
        <a onClick={handleReloadPageClick}>reload the page</a>.
      </p>
    </div>
  );
};

export default ErrorBoundaryFallback;
